(function ($) {
  if($('.related-blogs-content')){
      $('.related-blogs-content .list').addClass('swiper-wrapper');
      $('.related-blogs-content .list .item').addClass('swiper-slide');
      $('.related-blogs-content').addClass('swiper-article');
      var swiper = new Swiper(".swiper-article", {
        loop:true,
        allowTouchMove: true,
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768:{
            slidesPerView: 3,
            spaceBetween: 0,
          }
        }
      });
    }
  $(document).ready(function() {
    
    if($('.products-related-article').length>0) {
      $('.products-related-article').owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        margin: 40,
        items: 4,
        responsive:{
          0:{
            items: 1,
            margin: 17,
            loop: true
          },
          479:{
            items: 1,
            margin: 17,
            center: false
          },
          480:{
            items: 2,
            margin: 17,
            center: true
          },
          767:{
            items: 2,
            margin: 17,
            nav: false,
            center: true
          },
          768:{
            items: 2,
            margin: 30
          },
          1023:{
            items: 3,
            margin: 30
          },
          1200:{
            items: 4
          }
        }
      });
    }
    $(".article-detail .article-content a").removeAttr("title");
  });
})(jQuery);